import React, { forwardRef } from 'react'
import EssayRichText from 'pages/ApplicationDetailsPage/components/Essay/components/EssayRichText/EssayRichText'
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg'
import s from './styles/EssayContent.module.scss'

const EssayContent = forwardRef(function EssayContent(
	{
		loading = false,
		pendingUpdate = null,
		onApplyPendingUpdate,
		title = 'Essay',
		isEditing = false,
		onTitleChange,
		versionControl = null,
		versionNumber = null,
		universityName = null,
		isNew = false,
		updatedLabel = '',
		contentLabel = 'Student Essay',
		wordCount = 0,
		wordLimit = null,
		versionId,
		contentJson = null,
		contentText = '',
		onAnchorClick,
		onTextSelected,
		selectionDisabled = false,
		saving = false,
		onBackgroundClick,
	},
	editorRef,
) {
	const handlePaneClick = e => {
		if (!onBackgroundClick) return
		if (e.target === e.currentTarget) onBackgroundClick()
	}

	const hasMeta = Boolean(
		versionControl ||
			versionNumber != null ||
			universityName ||
			isNew ||
			updatedLabel,
	)

	const banner = pendingUpdate ? (
		<div className={s.updateBanner}>
			<span>The student updated this essay.</span>
			<button type="button" onClick={onApplyPendingUpdate}>
				Update essay
			</button>
		</div>
	) : null

	return (
		<main className={s.pane} onClick={handlePaneClick}>
			{banner}
			{loading ? (
				<p className={s.empty}>Loading essay...</p>
			) : (
				<>
					<section className={s.promptSection}>
						{hasMeta ? (
							<div className={s.promtHead}>
								<span className={s.sectionLabel}>Title</span>
								<div className={s.promtHead__inner}>
									{versionControl}
									{!versionControl && versionNumber != null ? (
										<span className={s.promptChip}>
											Version {versionNumber || '1'}
										</span>
									) : null}
									{universityName ? (
										<span className={s.promptSubtle}>{universityName}</span>
									) : null}
									{isNew ? <span className={s.newPill}>NEW</span> : null}
									{updatedLabel ? (
										<span className={s.updatedRow}>
											<ClockIcon />
											<span>Updated {updatedLabel}</span>
										</span>
									) : null}
								</div>
							</div>
						) : (
							<span className={s.sectionLabel}>Title</span>
						)}
						<div className={s.promptCard}>
							{isEditing ? (
								<input
									className={s.input}
									value={title}
									onChange={e => onTitleChange?.(e.target.value)}
								/>
							) : (
								<h1 className={s.heading}>{title || 'Essay'}</h1>
							)}
						</div>
					</section>
					<section className={s.contentSection}>
						<div className={s.contentHead}>
							<span className={s.sectionLabel}>{contentLabel}</span>
							<span className={s.wordCount}>
								<strong>
									{wordLimit != null
										? `${wordCount}/${wordLimit}`
										: wordCount}
								</strong>
								<span>words</span>
							</span>
						</div>
						<EssayRichText
							ref={editorRef}
							versionId={versionId}
							contentJson={contentJson}
							contentText={contentText || ''}
							isEditing={isEditing}
							className={s.editor}
							onAnchorClick={onAnchorClick}
							onTextSelected={onTextSelected}
							selectionDisabled={selectionDisabled}
						/>
					</section>
					{saving ? <span className={s.saving}>Saving...</span> : null}
				</>
			)}
		</main>
	)
})

export default EssayContent
